import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { COMMON_ENABEL_STATUS } from '@/constant/system/code';
import { uploadFileForName } from '@/api/file/file';
import { get, update } from '@/api/baseSetting/safeoperation/safeoperation';
import { ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message-box/style/css'

import { toast } from '@/utils/message';

import { ref, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Safeoperation',
  setup(__props) {
    const changing = ref(false);
    const file = ref();
    const formData = ref({
      id: 1,
      title: '',
      content: '<p></p>',
      countDown: 10,
      status: COMMON_ENABEL_STATUS.ENABLED.CODE
    });
    const editorConfig = {
      // 后端服务地址，后端处理参考
      // https://open-doc.modstart.com/ueditor-plus/backend.html
      serverUrl: process.env.VUE_APP_BASE_API + "/manage/ueditor/config",
      UEDITOR_HOME_URL: `${process.env.BASE_URL === '/' ? '' : process.env.BASE_URL}/UEditor/`,
      UEDITOR_CORS_URL: `${process.env.BASE_URL === '/' ? '' : process.env.BASE_URL}/UEditor/`,
      //是否启用粘贴上传
      //enablePasteUpload: false,
      //设置远程图片是否抓取到本地保存
      catchRemoteImageEnable: false
    };
    /**
     * 识别出所有135的图片，将其上传到本地服务器后，替换为最新资源
     */
    const handleChange = contentVal => {
      // 正则表达式匹配 src 属性值
      //https://bcn.135editor.com
      const regex = /src="https:\/\/bcn\.135editor\.[^"]*"/;
      // 找到第一个匹配项
      const match = contentVal.match(regex);
      if (match) {
        // 获取原始 src 值
        const originalSrc = match[0];
        // 加工处理逻辑
        convertUrlToFile(originalSrc);
      }
    };
    /**
     * 将135图片地址替换为本地服务器地址
     * @param imageUrl
     */
    const convertUrlToFile = async originalSrc => {
      const imageUrl = originalSrc.replace('src="', '').replace('"', '');
      try {
        // 1. 使用 fetch 获取图片的二进制数据
        const response = await fetch(imageUrl);
        if (!response.ok) {
          return;
        }
        // 2. 将响应数据转换为 Blob
        const blob = await response.blob();
        // 3. 提取文件名（可以从 URL 中解析，或自定义）
        const fileName = extractFileNameFromUrl(imageUrl);
        // 4. 创建 File 对象
        file.value = new File([blob], fileName, {
          type: blob.type
        });
        console.log('File 对象已创建:', file.value);
        await customUpload(file.value, originalSrc);
      } catch (error) {
        console.error('转换失败:', error);
        alert('转换失败，请检查图片 URL 是否有效');
      }
    };
    const extractFileNameFromUrl = url => {
      // 从 URL 中提取文件名（假设 URL 结尾是文件名）
      const urlParts = url.split('/');
      const fileNameWithExtension = urlParts[urlParts.length - 1];
      return fileNameWithExtension;
    };
    /**
     * 自定义上传文件到本地服务器，上传失败返回原文件
     * @param file
     * @param fileUrl
     */
    const customUpload = async (file, fileUrl) => {
      // 定义上传文件的目标路径
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
      const day = String(currentDate.getDate()).padStart(2, '0');
      const randomFileName = generateRandomString(20);
      const key = `safeoperationfile/${year}/${month}/${day}/${randomFileName}.${file.name.split('.').pop()}`;
      const uploadDate = new FormData();
      uploadDate.append('file', file);
      uploadDate.append('fileKey', key);
      uploadFileForName(uploadDate).then(res => {
        const imageUrl = `${process.env.VUE_APP_DOMAIN}/manage/upfile/getfile?filePath=${key}`; // 替换为服务后台接口URL
        // 替换回原字符串
        formData.value.content = formData.value.content.replace(fileUrl, 'src="' + imageUrl + '"');
        console.error("上传成功地址：" + imageUrl);
      }).catch(error => {
        toast.error('图片上传失败');
      });
    };
    // 辅助函数：生成随机字符串
    function generateRandomString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    }
    /**
     * 获取安全操作说明
     */
    function getSafeOperation() {
      get(1).then(res => {
        formData.value = res.data;
      }).catch(() => {});
    }
    /**
     * 进入画面默认执行一次
     */
    getSafeOperation();
    /**
     * 更新安全操作说明
     */
    function saveSafeOperation() {
      ElMessageBox.confirm('是否保存?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        update(formData.value).then(res => {
          toast.success('保存成功');
          getSafeOperation();
        }).catch(() => {});
      }).catch(() => {});
    }
    //变量监听
    watch(() => formData.value.content, (newValue, oldValue) => {
      if (!changing.value && newValue != null && newValue != '') {
        changing.value = true;
        handleChange(newValue);
        changing.value = false;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_ElSwitch = _resolveComponent("ElSwitch");
      const _component_vue_ueditor_wrap = _resolveComponent("vue-ueditor-wrap");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "form",
          model: _unref(formData)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "search-row"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12,
              class: "search-col"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "标题："
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(formData).title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).title = $event),
                  placeholder: "请输入标题"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "search-row"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 6,
              class: "search-col"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "提醒倒计时："
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  modelValue: _unref(formData).countDown,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).countDown = $event),
                  min: 1,
                  max: 333,
                  precision: 0
                }, null, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createTextVNode(" 秒 "))]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 6,
              class: "search-col"
            }, {
              default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("span", null, "启用/停用：", -1)), _createVNode(_component_ElSwitch, {
                modelValue: _unref(formData).status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).status = $event),
                "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
                "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE
              }, null, 8, ["modelValue", "active-value", "inactive-value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "search-row"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 18,
              class: "search-col"
            }, {
              default: _withCtx(() => [_createVNode(_component_vue_ueditor_wrap, {
                modelValue: _unref(formData).content,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).content = $event),
                "editor-id": "editor",
                config: editorConfig,
                editorDependencies: ['ueditor.config.js', 'ueditor.all.js', '135editor.js'],
                style: {
                  "max-height": "400px",
                  "height": "400px",
                  "overflow-y": "scroll"
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "search-row"
          }), _createVNode(_component_el_col, {
            span: 12,
            class: "search-button"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: getSafeOperation
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("刷新")])),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveSafeOperation
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("确认")])),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      });
    };
  }
});